app.controller("SeasonWeeksController", ["$scope", "Season", "$stateParams", "$uibModal", function ($scope, Season, $stateParams, $uibModal) {

  function fetchSeasonWeeks() {
    Season.getById($stateParams.seasonId)
      .then(function (season) {
        $scope.year = season.year;
        $scope.season = season.season;
        $scope.weeks = season.weeks;
      });
  }

  fetchSeasonWeeks();

  $scope.addWeek = function () {
    var weekNumber = $scope.weeks.length;

    $uibModal.open({
      controller: "AddSeasonWeekController",
      templateUrl: _pb + 'sudo/seasons/add-season-week.html',
      size: "md",
      resolve: {
        params: function () {
          return {
            seasonId: $stateParams.seasonId,
            weekNumber: weekNumber
          };
        }
      }
    }).result.then(function () {
      fetchSeasonWeeks();
    });
  };

  $scope.insertNext = function (week) {
    $uibModal.open({
      controller: "AddSeasonWeekController",
      templateUrl: _pb + 'sudo/seasons/add-season-week.html',
      size: "md",
      resolve: {
        params: function () {
          return {
            seasonId: $stateParams.seasonId,
            weekNumber: week.weekNumber,
            startDate: week.startDate,
            endDate: week.endDate
          };
        }
      }
    }).result.then(function () {
      fetchSeasonWeeks();
    });
  };

  $scope.edit = function (week) {
    $uibModal.open({
      controller: "EditSeasonWeekController",
      templateUrl: _pb + 'sudo/seasons/edit-season-week.html',
      size: "md",
      resolve: {
        params: function () {
          return {
            seasonId: $stateParams.seasonId,
            weekNumber: week.weekNumber,
            startDate: week.startDate,
            endDate: week.endDate
          };
        }
      }
    }).result.then(function () {
      fetchSeasonWeeks();
    });
  };

  $scope.delete = function (week) {
    Season.deleteWeek($stateParams.seasonId, week.weekNumber)
      .then(function () {
        fetchSeasonWeeks();
      });
  };


}]);
